/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Redux
import { REGISTERED, GUEST, GENERIC } from "../../constants/user";
import { RootReducerState } from "../reducers";
import { BUYER_ADMIN_ROLE, BUYER_ROLE, SELLER_ROLE } from "constants/common";

const userTypeSelector = (state: RootReducerState) => {
  if (state.user.userLoggedIn) {
    return REGISTERED;
  } else if (state.user.isGuest) {
    return GUEST;
  } else {
    return GENERIC;
  }
};

const loginStatusSelector = (state: RootReducerState) => {
  return state.user.userLoggedIn || false;
};

const loginErrorMsgSelector = (state: RootReducerState) => {
  return state.user.userLoginErrorMsg;
};
const guestStatusSelector = (state: RootReducerState) => {
  return state.user.isGuest || false;
};
const rememberMeSelector = (state: RootReducerState) => {
  return state.user.rememberMe || false;
};
const wcTokenSelector = (state: RootReducerState) => {
  return state.user.WCToken;
};
const wcTrustedTokenSelector = (state: RootReducerState) => {
  return state.user.WCTrustedToken;
};

const logonIdSelector = (state: RootReducerState) => {
  return state.user.details?.logonId || "";
};

const userIdSelector = (state: RootReducerState) => {
  return state.user.userId;
};

const forUserIdSelector = (state: RootReducerState) => {
  return state.user.forUserId;
};

const rolesWithDetailsSelector = (state: RootReducerState) => {
  return state.user.rolesWithDetails;
};

const isSellerSelector = (state: RootReducerState) => {
  return state.user.rolesWithDetails?.some((x) => x.roleId === SELLER_ROLE) || false;
};

const isBuyerSelector = (state: RootReducerState) => {
  return state.user.rolesWithDetails?.some((x) => x.roleId === BUYER_ROLE) || false;
};

const isBuyerAdminSelector = (state: RootReducerState) => {
  return state.user.rolesWithDetails?.some((x) => x.roleId === BUYER_ADMIN_ROLE) || false;
};

const userNameSelector = (state: RootReducerState) => {
  const firstName = state.user.details?.firstName || "";
  const lastName = state.user.details?.lastName || "";
  return { firstName, lastName };
};

const userInitStatusSelector = (state: RootReducerState) => {
  return state.user.initiatedFromStorage;
};

const userLastUpdatedSelector = (state: RootReducerState) => {
  return state.user.lastUpdated;
};

const registrationStatusSelector = (state: RootReducerState) => {
  return state.user.userRegistration || false;
};

const subscribeToNewsletterSelector = (state: RootReducerState) => {
  const values = state.user.details?.receiveEmailPreference?.map((v) => v.value?.toLowerCase() === "true");
  return values?.length > 0 ? values[0] : false;
};

export {
  loginStatusSelector,
  loginErrorMsgSelector,
  guestStatusSelector,
  wcTokenSelector,
  wcTrustedTokenSelector,
  logonIdSelector,
  registrationStatusSelector,
  userNameSelector,
  userIdSelector,
  userInitStatusSelector,
  userLastUpdatedSelector,
  forUserIdSelector,
  rolesWithDetailsSelector,
  isSellerSelector,
  subscribeToNewsletterSelector,
  isBuyerAdminSelector,
  isBuyerSelector,
  rememberMeSelector,
  userTypeSelector,
};
